const FORBIDDEN_MESSAGE =
  "Oops! You don't have permission to access this workflow. Please contact the workflow creator.";
const NOT_FOUND_MESSAGE =
  "Oops! Something went wrong, Please contact your administrator";
const FORBIDDEN_CODE = 403;

module.exports = { FORBIDDEN_MESSAGE, NOT_FOUND_MESSAGE, FORBIDDEN_CODE };
